import Alpine from 'alpinejs'
import { isMenuMobile } from '../utils/utils'

export const initSubmenu = (): void => {
    Alpine.data('submenu', () => ({
        open: false,
        toggleSubmenu() {
            this.open = !this.open
        },
        focusoutHandler() {
            if (!isMenuMobile()) {
                setTimeout(() => {
                    const focusedLink = this.$el.querySelector('.header__nav-link:focus')
                    const focusedToggle = this.$el.querySelector('.header__nav-toggle:focus')

                    if (!focusedLink && !focusedToggle) {
                        this.open = false
                    }
                }, 50)
            }
        },
    }))
}
